import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import React from 'react';
import {
  individual_column_style,
  individual_header_style
} from 'assets/styles/table_custom_style';
import FlexTable from 'components/FlexTable';

export const AnalyticalOpportunityTime = ({ data, sortConfig, setSortConfig }) => {
  const createDynamicColumns = () => {
    const columns = [];

    columns.push(
      {
        dataField: 'opportunity_title',
        text: 'Título da Oportunidade',
        sort: true,
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_cell, { opportunityTitle }) => opportunityTitle
      },
      {
        dataField: 'stage_name',
        text: 'Fase da Oportunidade',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_cell, { stageName }) => stageName
      },
      {
        dataField: 'stage_time',
        text: 'Dias na fase',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_cell, { stageTime }) => stageTime
      },
      {
        dataField: 'moved_at_time',
        text: 'Movimentado dentro do prazo',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_cell, { movedAtTime }) => movedAtTime ? "SIM" : "NÃO"
      }
    );

    return [...columns];
  };

  const dynamicFunctionColumns = createDynamicColumns();

  return (
    <ToolkitProvider
      data={data || []}
      keyField="id"
      columns={dynamicFunctionColumns}
    >
      {(props) => (
        <div className="py-4 table-responsive">
          <FlexTable
            entityName="opportunityTime"
            bootstrap4={true}
            bordered={false}
            classes="align-items-center"
            setSortConfig={setSortConfig}
            sortConfig={sortConfig}
            {...props.baseProps}
          />
        </div>
      )}
    </ToolkitProvider>
  );
};